module.exports = __webpack_public_path__ + "static/media/faq_register_black.13ea7fc7.svg";